import {LabeledTextInput} from "../../components/input/LabeledTextInput";
import React, {useState} from "react";
import {LabeledCountryInput} from "../../components/input/LabeledCountryInput";
import {AcceptTosInput} from "./AcceptTosInput";
import {space, UpdateProviderProfileRequest, UpdateProviderProfileResponse,} from "../../provider_api";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {findError} from "../../components/input/InputTypes";
import {useRpcSender} from "../../util/RpcSender";
import {RpcState} from "../../util/RpcState";
import {ActionButton} from "../../util/UI/ActionButton";
import IErrorProto = space.kenko.proto.IErrorProto;
import IProviderProfileProto = space.kenko.proto.IProviderProfileProto;
import ProviderProfileProto = space.kenko.proto.ProviderProfileProto;

type Props = {

  /**
   * When the profile saves successfully this gets called so the onboarding
   * can proceed to the next step.
   */
  onAdvance: () => void;
}

export const CreateProfile = (props: Props) => {

  const rpcSender = useRpcSender();
  const {provider, setProvider} = useProviderProfile();

  const [workingProfile, setWorkingProfile] = useState<IProviderProfileProto>(
      provider?.profile ?? new ProviderProfileProto({countryCode: 'US'}));

  const [errors, setErrors] = useState<IErrorProto[]>([])
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});

  const submit = () => {

    setErrors([]);
    setRpcState({state: 'pending'})

    let request = UpdateProviderProfileRequest.encode(new UpdateProviderProfileRequest({
      profile: workingProfile
    })).finish();

    rpcSender.send('update_provider_profile', request)
        .then(resp => {
          let response = UpdateProviderProfileResponse.decode(resp);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'Please check for errors.'})
            setErrors(response.fatalErrors);
            return;
          }

          setRpcState({state: 'success'})
          setErrors(response.fatalErrors);
          setProvider(response.provider);
          props.onAdvance();

        }).catch(e => {
      setRpcState({state: 'error', message: 'Network error. Please try again later'})
    });
  }

  // This mimics the style of the NewProviderSurvey which follows it
  return <div className={'SurveySection'}>
    <h2>Create your profile</h2>

    <LabeledTextInput label={'First name'}
                      value={workingProfile.firstName}
                      error={findError(errors, 'firstName')} inputType={'text'}
                      onChange={v => {
                        setWorkingProfile({
                          ...workingProfile,
                          firstName: v
                        })
                      }}/>

    <LabeledTextInput label={'Last name'}
                      value={workingProfile.lastName}
                      error={findError(errors, 'lastName')} inputType={'text'}
                      onChange={v => {
                        setWorkingProfile({
                          ...workingProfile,
                          lastName: v
                        })
                      }}/>


    <LabeledCountryInput label={'Country'}
                         value={workingProfile.countryCode}
                         error={findError(errors, 'countryCode')}
                         onChange={v => {
                           setWorkingProfile({
                             ...workingProfile,
                             countryCode: v
                           })
                         }}/>


    <AcceptTosInput value={workingProfile.agreedToTerms ?? false}
                    error={findError(errors, 'agreedToTerms')}
                    onChange={v => {
                      setWorkingProfile({
                        ...workingProfile,
                        agreedToTerms: v
                      })
                    }}/>
    
    <ActionButton rpcState={rpcState} onClick={submit}>Join Kensu</ActionButton>
  </div>
}